module.exports = __webpack_public_path__ + "img/flot6.40a3af48.svg";